export default "__VITE_ASSET__D4C3SdfK__"